// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__24cYq","header":"ReportDetails_header__3j1bZ","title":"ReportDetails_title__2Zdi4","left":"ReportDetails_left__1O9s3"};